import React from 'react'
import { IconAlert, ModalClosed, ModalSuccess } from '~misc/icons';
import { Link } from "react-router-dom";

import useHeader from '~components/Header/hooks/useHeader';

const ModalCreateProduct = ({ isOpen, onClose, title, sub, buttonOne, linkOne,buttonTwo, action  }) => {
    const modalClasses = isOpen ? 'fixed inset-0 bg-black bg-opacity-0 z-[99999]' : 'hidden';
    const overlayClasses = isOpen ? 'fixed inset-0 bg-black opacity-50 z-40' : 'hidden';
    const { path} = useHeader();
    function handleClick (onClose, state){
        action(state)
        onClose()
    }
    return (
      <div className={modalClasses}>
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-white px-14 py-14 rounded-[20px] shadow-lg z-50 text-center relative">
          <div className="flex justify-end">
            <button type='button' onClick={onClose} className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0">
              <ModalClosed />
            </button>
          </div>
          <IconAlert />
          <h3 className='font-bold text-4xl max-w-[400px] text-recusado '>{title}</h3>
          <h4 className='mt-2 ' >{sub}</h4>
          <div className="flex justify-center gap-3 mt-3">
            {buttonOne && (
            <Link to={linkOne}>
              <button type='button' className='px-6 py-3 rounded bg-transparent text-recusado font-bold  hover:bg-white hover:text-recusado border-2 border-recusado border-quartenaria transition duration-300 ease-in-out' onClick={()=> handleClick(onClose, false)}>
                  {buttonOne}
              </button>
            </Link>
            )}
            {buttonTwo && (
              <button type='button' className='px-6 py-3 rounded bg-quaternaria text-white font-bold  hover:bg-white hover:text-quaternaria border-2 border-quaternaria border-quartenaria transition duration-300 ease-in-out' onClick={()=> handleClick(onClose, true)}>
                  {buttonTwo}
              </button>
            )}

          </div>
        </div>
        <div className={overlayClasses} onClick={onClose}></div>
      </div>
    </div>
    )
}

export default ModalCreateProduct
